export const UltraLight = 'AvenirNextUltraLight';
export const DemiBold = 'AvenirNextDemiBold';
export const Heavy = 'AvenirNextHeavy';
export const Medium = 'AvenirNextMedium';
export const Bold = 'AvenirNextBold';
export const Regular = 'AvenirNext';
